import React /*, { ReactNode }*/ from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { ReactComponent as AISVG } from '../../assets/ai_star.svg';
import { showProfile } from '../../features/dialogSlice';

interface RecommendationsProps {
    AIRecommendations: any
}

export const Recommendations: React.FC<RecommendationsProps> = ({ AIRecommendations }) => {
    const dispatch = useDispatch<any>();
    function editStory() {
        dispatch(showProfile({ isForced: true }))
    }

    //console.log(AIRecommendations)
    if (Object.keys(AIRecommendations).length > 0) {
        return (
            <Box sx={{
                border: '1px solid #E8E4FF',
                borderRadius: 3,
                backgroundColor: '#F5F3FF',
                boxShadow: '0 2px 8px rgba(101,110,255,0.08)',
                p: 2.5,
                mt: 2,
            }}>
                <Stack direction="column" gap={1.5}>
                    <Stack direction="row" alignItems="flex-start" gap={1.5}>
                        <AISVG style={{ height: 28, width: 28, flexShrink: 0, marginTop: 2 }} />
                        <Stack direction="column" gap={0.5}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1a1a2e', lineHeight: 1.3, fontSize: 15 }}>
                                Share more to unlock deeper insights
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.5 }}>
                                Adding more details to your profile helps us find better matches and give you more relevant insights.
                            </Typography>
                        </Stack>
                    </Stack>
                    <Button
                        onClick={editStory}
                        variant="contained"
                        disableElevation
                        sx={{
                            alignSelf: 'flex-start',
                            backgroundColor: '#656EFF',
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            px: 2.5,
                            boxShadow: '0 2px 8px rgba(101,110,255,0.25)',
                        }}
                    >
                        Update my story
                    </Button>
                </Stack>
            </Box>
        );
    } else {
        return null
    }
}